import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { QuestionAttemptModel } from 'app/teacher/models/question-attempt.model';

@Injectable({
  providedIn: 'root'
})
export class StudentQuestionAttemptService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getQuestionAttempt(attemptId: string, itemOrder: number): Observable<QuestionAttemptModel> {
    const url = this.urlService.buildServerApiUrl('Teacher/QuestionAttempt', attemptId, itemOrder.toString());

    return this.http.get<QuestionAttemptModel>(url);
  }
}
